<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64" class="px-6" elevation="2">
          <v-toolbar
            flat
            floating
          >
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              class="mr-4"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>

            </v-btn>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Aujourd'hui
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>

            <v-spacer></v-spacer>
          </v-toolbar>
      </v-sheet>
      <v-sheet>
      <v-row align="center">
        <v-spacer></v-spacer>
        <v-toolbar-title v-if="$refs.calendar" >
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-row>
      </v-sheet>
      <v-sheet height="800" class="px-6" elevation="2">
          <v-calendar
            ref="calendar"
            v-model="focus"
            :first-interval="5"
            :interval-minutes="60"
            :interval-count="14"
            :events="schedule"
            :event-color="event_color"
            color="head-color"
            type="week"
            :short-weekdays="responsive"
            locale="fr"
            class="height: 300"
            @change="fetchEvents"

          >
          </v-calendar>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.head-color {
  background-color: #018891 !important;
  color: white !important;
  &--text {
    color: #018891 !important;
  }
}
.event-color {
  background-color: #018891 !important;
  color: white !important;
  padding: 10px;
}
@media only screen and (max-width: 900px) {
  .event-color {
    color: #018891 !important;
  }
  .v-btn--fab.v-size--default {
    height: 28px !important;
    width: 28px !important;
  }
}
</style>

<script>
export default {
  data: () => ({
    responsive: window.innerWidth < 900,
    focus: '',
    schedule: [],
    data_schedule: [
      {
        name: "horaire",
        start: "2020-10-26 09:00",
        end: "2020-10-26 16:00"
      },
      {
        name: "horaire",
        start: "2020-10-27 07:00",
        end: "2020-10-27 15:00"
      },
      {
        name: "horaire",
        start: "2020-10-28 07:00",
        end: "2020-10-28 14:00"
      }
    ],
    event_color: "event-color"
  }),
  mounted () {
    this.$refs.calendar.checkChange()
  },
  methods: {
    getEventColor(event) {
      return "blue";
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    setToday () {
      this.focus = ''
    },
    fetchEvents(){
      this.schedule = this.data_schedule
    }
  }
};
</script>
